import {} from "@/api/schema";
import {} from "./CleanableSummary";
import {} from "./CleanupResult";
export class PaginationOptions {
    constructor(props) {
        Object.defineProperty(this, "limit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "offset", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sortBy", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sortDesc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.limit = props?.limit;
        this.offset = props?.offset;
        this.sortBy = props?.sortBy;
        this.sortDesc = props?.sortDesc;
    }
    get order() {
        return this.sortBy ? `${this.sortBy}${this.sortDesc ? "-dsc" : "-asc"}` : undefined;
    }
}
